import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "best-price-selection" }
const _hoisted_2 = { class: "best-price-selection__filter-button-left" }
const _hoisted_3 = { class: "best-price-selection__filter-button--text" }

import BaseIcon from '@lmt-rpb/BaseIcon/BaseIcon.vue';
import { formatDate } from '@/js/utils/dateTimeUtils';
import { computed } from 'vue';
import { useStore } from '@/components/common/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'BestPriceSelection',
  props: {
    filter: { default: '' }
  },
  emits: ['deleteFilter'],
  setup(__props: any, { emit: __emit }) {

const store = useStore();

const props = __props;

const emit = __emit;

const formData = computed(() => store.state.searchMask);

const offerType = computed((): 'package' | 'hotel' => (formData.value.onlyHotel ? 'hotel' : 'package'));

const getFilterBtnLabel = (): string => {
	if (!props.filter) {
		return '';
	}

	const weekday = formatDate(props.filter, { weekday: 'long' });
	const formatted = formatDate(props.filter, { year: 'numeric', month: '2-digit', day: '2-digit' });
	return `${weekday}, ${formatted}`;
};

const deleteFilter = () => {
	emit('deleteFilter');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.filter)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "best-price-selection__filter-button",
          onClick: deleteFilter
        }, [
          _createElementVNode("div", _hoisted_2, [
            (offerType.value === 'package')
              ? (_openBlock(), _createBlock(BaseIcon, {
                  key: 0,
                  name: "planeGo",
                  class: "best-price-selection__plane-icon"
                }))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_3, [
              _cache[0] || (_cache[0] = _createElementVNode("span", null, "Hinreise am ", -1 /* HOISTED */)),
              _createElementVNode("strong", null, _toDisplayString(getFilterBtnLabel()), 1 /* TEXT */)
            ])
          ]),
          _createVNode(BaseIcon, {
            name: "cancel",
            class: "best-price-selection__cancel-icon"
          })
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})